__webpack_require__.p = "/exchange-rate/";